import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { CrmInvoiceResponse, ReduxEntity } from 'Douleutaras/types';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { extractIds, normalizeItems } from 'Douleutaras/utilities/redux/normalizeItems';

const TRANSACTIONS_ENDPOINT = 'api/public/transactions';

const transactionsAdapter = createEntityAdapter<CrmInvoiceResponse>();

export const getTransactions = createAsyncThunk(
  'transactions/get',
  async (page: string, api) => {
    const response = await makeRequest(
      `${TRANSACTIONS_ENDPOINT}/`,
      {
        method: 'GET',
        additionalGetParams: {
          page
        }
      }
    )(api);

    const normalizedResults = normalizeItems(response.data.results);

    return { ...response.data, normalizedResults };
  }
);

export const transactionsSlice = createSlice({
  name: 'transactionItems',
  initialState: transactionsAdapter.getInitialState({
    totalTransactions: 0,
    currentPageItems: [],
    entities: {},
    downloadUrl: ''
  } as ReduxEntity<CrmInvoiceResponse> & {
    totalTransactions: number;
    currentPageItems: Array<number>;
    downloadUrl: string
  }),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getTransactions.fulfilled, (state, action) => {
      transactionsAdapter.upsertMany(state, action.payload.normalizedResults || {});
      state.totalTransactions = action.payload.count;
      state.downloadUrl = action.payload.download_all_link;
      state.currentPageItems = extractIds(action.payload.results);
    });
  }
});
